import { render, staticRenderFns } from "./LineaTiempo.vue?vue&type=template&id=bed94410"
import script from "./LineaTiempo.vue?vue&type=script&lang=js"
export * from "./LineaTiempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports